"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doughnutSchemaValidator = exports.doughnutSchema = exports.doughnutFieldSchemaValidator = exports.DoughnutSummarizationType = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
var DoughnutSummarizationType;
(function (DoughnutSummarizationType) {
    DoughnutSummarizationType["AVG"] = "AVG";
    DoughnutSummarizationType["SUM"] = "SUM";
    DoughnutSummarizationType["COUNT"] = "COUNT";
    DoughnutSummarizationType["MAX"] = "MAX";
    DoughnutSummarizationType["MIN"] = "MIN";
    DoughnutSummarizationType["COUNT_DISTINCT"] = "COUNT_DISTINCT";
})(DoughnutSummarizationType = exports.DoughnutSummarizationType || (exports.DoughnutSummarizationType = {}));
exports.doughnutFieldSchemaValidator = zod_1.z.object({
    color: zod_1.z.string().min(1),
    label: zod_1.z.string().optional(),
    value: zod_1.z.string().min(1, { message: 'Campo obrigatório' }),
});
exports.doughnutSchema = zod_1.z.object({
    metric_column_id: zod_1.z.string().min(1, { message: 'Campo obrigatório' }),
    grouped_column_id: zod_1.z.string().min(1, { message: 'Campo obrigatório' }),
    summarization_type: zod_1.z.nativeEnum(DoughnutSummarizationType),
    others_color: zod_1.z.string().optional(),
    filter: common_1.widgetFilterValidator.optional(),
    doughnut_fields: zod_1.z.array(exports.doughnutFieldSchemaValidator),
});
exports.doughnutSchemaValidator = zod_1.z.intersection(common_1.commonTypeSchemaValidator, exports.doughnutSchema);
